<template>
    <div id="editor" class="col-sm-12 nopads">
        <div class="col-sm-12 editor-form" @click.stop="">
            <h2 class="editor-header">
                {{ $t('mvr_inspection.inspectable_editor.inspectable') }}
            </h2>
            <div class="row">
                <div class="col-sm-12 form-data">
                    <span class="span-title mb-2">{{ $t('mvr_inspection.inspectable_editor.section_header') }}</span>
                    <textarea class="form-control form-control-mb" rows="4" v-model="inspectable.text"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 button-container">
                <button class="btn form-button btn-danger" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                </button>
                <button class="btn form-button btn-success" :disabled="loading" @click.stop="submitInspectable">
                        {{ $t('common.save') }}
                </button>
            </div>
        </div>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'MvrInspectableEditor',
    mixins: [restApi],
    props: {
        editInspectable: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            inspectable: {
                id: null,
                text: '',
            },
            inspections: [],
        }
    },
    watch: {},
    mounted() {
        if (this.editInspectable) {
            this.inspectable = JSON.parse(JSON.stringify(this.editInspectable))
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    methods: {
        submitInspectable() {
            this.loading = true
            let inspectablePayload = JSON.parse(JSON.stringify(this.inspectable))
            if (inspectablePayload.id && inspectablePayload.id > 0) {
                this.restUpdate(this.mvrInspectableUrl, inspectablePayload, () => {
                    this.loading = false
                    this.$emit('closeAndUpdate')
                    this.showAlert(this.$t('mvr_inspection.inspectable_editor.update_success'), 'success')
                }, () => {
                    this.loading = false
                    this.showAlert(this.$t('mvr_inspection.inspectable_editor.update_failed'))
                })
            } else {
                this.restAdd(this.mvrInspectableUrl, inspectablePayload, () => {
                    this.loading = false
                    this.$emit('closeAndUpdate')
                    this.showAlert(this.$t('mvr_inspection.inspectable_editor.create_success'), 'success')
                }, () => {
                    this.loading = false
                    this.showAlert(this.$t('mvr_inspection.inspectable_editor.create_failed'))
                })
            }
        },
    }
}
</script>
